export const FONOTEKA_QUERY_KEY = ['fonoteka'] as const;

/** Окно выбора треков (порции проектов Фонотеки, их треки): отдельно от полного каталога — тот грузит только раздел «Фонотека» */
export const FONOTEKA_LAZY_QUERY_ROOT = ['fonoteka-lazy'] as const;

export function fonotekaPackSummariesKey(projectId: string, q: string) {
  return [...FONOTEKA_LAZY_QUERY_ROOT, 'summaries', projectId, q] as const;
}

export function fonotekaPackTracksKey(packId: string) {
  return [...FONOTEKA_LAZY_QUERY_ROOT, 'pack-tracks', packId] as const;
}

export const PROJECT_FONOTEKA_TRACKS_ROOT = ['projectFonotekaTracks'] as const;

export function projectFonotekaTracksKey(projectId: string) {
  return [...PROJECT_FONOTEKA_TRACKS_ROOT, projectId] as const;
}
